export const validateName = (name) => {
    const nameRegex = /^[a-zA-Z ]*$/; // Only letters and spaces allowed
    return nameRegex.test(name);
  };
  
  export const validateMobile = (mobile) => {
    const mobileRegex = /^[6-9]\d{9}$/; // Starts with 6, 7, 8, or 9, followed by 9 digits
    return mobileRegex.test(mobile);
  };
  
  
  export const validateDecimal = (value) => {
    const decimalRegex = /^\d+(\.\d{1,3})?$/; // Matches numbers with up to 3 decimal places
    return decimalRegex.test(value);
};

export const validateNamewithNumber = (name) => {
  const nameRegex = /^[a-zA-Z0-9 ]*$/; // Allows letters, numbers, and spaces
  return nameRegex.test(name);
};

export const validateNamewithoutSpace = (name) => {
  const nameRegex = /^[a-zA-Z0-9]*$/; // Allows letters, numbers
  return nameRegex.test(name);
};

export const validateAddress = (address) => {
  const addressRegex = /^[a-zA-Z0-9\s,.-/]{5,100}$/; 
  // Allows letters, numbers, spaces, commas, periods, and hyphens. Minimum 10 characters, max 100.
  return addressRegex.test(address);
};

export const validatePassword = (password) => {
  const passwordRegex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*()-_+=]*$/;
  return passwordRegex.test(password);
};

export function validateFabricContent(value) {
  // Accepts letters, letters with numbers, but not numbers only
  return /[a-zA-Z]/.test(value); // Must contain at least one letter
}
